import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    affiliate: {
      balance: {
        header: 'HEADER',
        withdrawal_button: 'WITHDRAWAL_BUTTON',
        download_report_button: 'DOWNLOAD_REPORT',
        statuses: {
          income: 'STATUS_INCOME',
          pending: 'STATUS_PENDING',
          paid: 'STATUS_PAID',
          canceled: 'STATUS_CANCELED',
          adjustment: 'STATUS_ADJUSTMENT',
        },
        withdrawal: {
          header: 'WITHDRAWAL_HEADER',
        },
      },
    },
  }));
}
